export default __webpack_public_path__ + "uploads-white-icon.svg";